export default class Supplier {
  constructor(
    public id: string,
    public name: string,
    public code: string,
    public document: string,
    public supplier_account_digit: string,
    public supplier_account_number: string,
    public supplier_account_type: string,
    public supplier_agency: string,
    public supplier_agency_digit: string,
    public supplier_bank: string,
  ) {}

  static make(data: any): Supplier {
    return new Supplier(
      data.id,
      data.name,
      data.code,
      data.document ?? '',
      data.supplier_account_digit ?? '',
      data.supplier_account_number ?? '',
      data.supplier_account_type ?? '',
      data.supplier_agency ?? '',
      data.supplier_agency_digit ?? '',
      data.supplier_bank ?? '',
    );
  }
}
